import _ from 'lodash';

export const getBorrowerName = loanHeader => {
  const firstName = _.trim(loanHeader?.primaryBorrowerFirstName ?? '');
  const lastName = _.trim(loanHeader?.primaryBorrowerLastName ?? '');

  return _.trim(`${firstName} ${lastName}`);
};

export const getMilestoneValue = loanHeader => {
  const name = _.trim(loanHeader?.milestoneStatusText ?? '');

  return name ? { name } : null;
};
